export default __webpack_public_path__ + "static/media/lp-sec07_benefits01.83bf380e.png";